(function($) {

	'use strict'

	var init = function() {
    	// console.log('home')
	}

	$(document).ready(function() {
		if ($('body').hasClass('home'))
			init()
	})

})(jQuery)
